export type MediaQuerySizeType = 's' | 'm' | 'l' | 'xl';
export const MEDIA_QUERY_SIZE: { [key: string]: MediaQuerySizeType } = {
	SMALL: 's',
	MEDIUM: 'm',
	LARGE: 'l',
	EXTRA_LARGE: 'xl'
};
